import { UserRoles } from 'types';

export const UserRoleNames = {
  [UserRoles.ADMIN]: 'Admin',
  [UserRoles.SERVICE_MANAGER]: 'Service Manager',
  [UserRoles.SERVICE_ADVISOR]: 'Service Advisor',
  [UserRoles.TECHNICIAN]: 'Technician',
  [UserRoles.PARTS_ADVISOR]: 'Parts Advisor',
  [UserRoles.SALES_MANAGER]: 'Sales Manager',
  [UserRoles.SALES_AGENT]: 'Sales Agent',
  [UserRoles.FINANCE_MANAGER]: 'Finance Manager',
  [UserRoles.GLOBAL_PAY]: 'Global Pay',
  [UserRoles.NONE]: 'None',
} as const;
